export default function user(state = [], action) {
  switch (action.type) {
    case 'ADD_DATA_USER':
      return { ...state, data: action.data };
    default:
      return state;
  }
}
